import { VueExtension } from '../../utils/extensions/vue'
import ChartColumn from './chartcolumn.jsx'
import './chartcolumn.scss'

VueExtension.WithInstall(ChartColumn)

export default ChartColumn